import { createFileRoute } from '@tanstack/react-router'
import { FreeSWITCHGatewaysPage } from '@/features/freeswitch'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/freeswitch/gateways/')(
  {
    component: FreeSWITCHGatewaysPage,
    beforeLoad: requireRole(['admin']),
  },
)
